<template>
	<div>
		<el-table border :data="tableData" style="width: 100%">
            <el-table-column type="index" label="序号" width="150"> </el-table-column>
            <el-table-column property="cj" label="车间" width="150"></el-table-column>
            <el-table-column property="jt" label="机台" width="150"></el-table-column>
            <el-table-column property="detail" label="具体操作" width="300"></el-table-column>
            <el-table-column property="time" label="操作时间" width="250"></el-table-column>
            <el-table-column property="num" label="工单号" width="150"></el-table-column>
            <el-table-column property="staff" label="操作人员" width="150"></el-table-column>
		</el-table>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [
					{
						cj: '车间001',
						jt: '机台001',
						detail: '',
						time : '2020-5-19；17:47',
                        num: '123456',
                        staff: '小明',
					},{
						cj: '车间002',
						jt: '机台002',
						detail: '',
						time : 'yyyy-mm-dd;hh:mm',
                        num: '123456',
                        staff: '小明',
					},
				],
			}
		},
		methods: {

		},
	}
</script>

<style></style>
